export const TestIds = {
  overlay: 'bannerOverlay',
  logo: 'bannerLogo',
  content: 'bannerContent',
  freemiumButtonDesktop: 'freemium-button',
  freemiumTextDesktop: 'freemium-text',
  freemiumTextMobile: 'freemium-text-mobile',
} as const;

export const freemiumBannerExperiments = {
  usePreferredApp: 'specs.thunderbolt.freemiumBannerMobileUsePreferredApp',
  newBannerMobile: 'specs.thunderbolt.WixFreeSiteBannerMobile',
  newBannerDesktop: 'specs.thunderbolt.WixFreeSiteBannerDesktop',
} as const;
